/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

/**
 * @summary List materials
 */

export const listMaterialsQueryPerPageMax = 100;

export const listMaterialsQueryStateDefault = `ACTIVE`;
export const listMaterialsQuerySortKeyDefault = `materialId`;

export const ListMaterialsQueryParams = zod.object({
  page: zod.coerce.number().int().min(1).describe("Page number (1-indexed)"),
  perPage: zod.coerce
    .number()
    .int()
    .min(1)
    .max(listMaterialsQueryPerPageMax)
    .describe("Number of items per page"),
  q: zod.coerce
    .string()
    .optional()
    .describe("Case-insensitive substring search across Material code or name"),
  state: zod
    .enum(["ACTIVE", "DELETED", "ALL"])
    .default(listMaterialsQueryStateDefault)
    .describe("Material state filter"),
  compositionKind: zod
    .enum(["SIMPLE", "COMPOSITE"])
    .optional()
    .describe("Material composition-kind filter"),
  supplyStatus: zod
    .enum(["SUPPLIED", "UNSUPPLIED"])
    .optional()
    .describe("Material supply-status filter"),
  functionId: zod.uuid().optional().describe("Assigned Material Function id"),
  unitOfMeasure: zod
    .enum(["KG", "M", "L", "UNIT", "M2", "M3"])
    .optional()
    .describe("Material unit-of-measure filter"),
  sortKey: zod
    .enum(["materialId", "code", "name"])
    .default(listMaterialsQuerySortKeyDefault)
    .describe("Material sort key"),
  sortDir: zod.enum(["asc", "desc"]).optional().describe("Sort direction"),
});

export const listMaterialsResponseItemsItemComponentsItemOneOneQuantityExclusiveMin = 0;

export const listMaterialsResponseItemsItemComponentsItemTwoOneQuantityExclusiveMin = 0;

export const listMaterialsResponseMetaTotalMin = 0;

export const ListMaterialsResponse = zod.object({
  items: zod.array(
    zod.object({
      materialId: zod.uuid().describe("Identity shared by Material and Service Catalog Items."),
      kind: zod.enum(["MATERIAL"]),
      state: zod.enum(["ACTIVE", "DELETED"]),
      createdAt: zod.iso.datetime({offset: true}),
      updatedAt: zod.iso.datetime({offset: true}),
      deletedAt: zod.iso.datetime({offset: true}).nullable(),
      code: zod.string(),
      name: zod.string(),
      internalDescription: zod.string(),
      priceProtected: zod.boolean(),
      unitOfMeasure: zod
        .unknown()
        .and(zod.unknown())
        .and(zod.unknown())
        .and(zod.unknown())
        .and(zod.unknown())
        .and(zod.unknown())
        .and(
          zod.object({
            code: zod.enum(["KG", "M", "L", "UNIT", "M2", "M3"]),
            name: zod.string(),
            symbol: zod.string(),
          }),
        )
        .describe("Fixed physical Material unit entry."),
      descriptionEntries: zod.array(
        zod.object({
          language: zod.enum(["ES", "EN", "FR"]).describe("Supported business language."),
          text: zod.string(),
        }),
      ),
      functionIds: zod.array(zod.uuid().describe("Material Function identity.")),
      compositionKind: zod.enum(["SIMPLE", "COMPOSITE"]),
      supplyStatus: zod.enum(["SUPPLIED", "UNSUPPLIED"]),
      components: zod.array(
        zod.union([
          zod
            .object({
              componentCatalogItemId: zod
                .uuid()
                .describe("Identity shared by Material and Service Catalog Items."),
              state: zod.enum(["ACTIVE", "DELETED"]),
              code: zod.string(),
              name: zod.string(),
              quantity: zod
                .number()
                .gt(listMaterialsResponseItemsItemComponentsItemOneOneQuantityExclusiveMin)
                .describe(
                  "Positive quantity interpreted using the referenced Catalog Item unit or billing unit.",
                ),
              supplyStatus: zod.enum(["SUPPLIED", "UNSUPPLIED"]),
            })
            .and(
              zod.object({
                kind: zod.enum(["MATERIAL"]),
                unitOfMeasure: zod
                  .unknown()
                  .and(zod.unknown())
                  .and(zod.unknown())
                  .and(zod.unknown())
                  .and(zod.unknown())
                  .and(zod.unknown())
                  .and(
                    zod.object({
                      code: zod.enum(["KG", "M", "L", "UNIT", "M2", "M3"]),
                      name: zod.string(),
                      symbol: zod.string(),
                    }),
                  )
                  .describe("Fixed physical Material unit entry."),
              }),
            )
            .and(
              zod.object({
                kind: zod.enum(["MATERIAL"]),
              }),
            ),
          zod
            .object({
              componentCatalogItemId: zod
                .uuid()
                .describe("Identity shared by Material and Service Catalog Items."),
              state: zod.enum(["ACTIVE", "DELETED"]),
              code: zod.string(),
              name: zod.string(),
              quantity: zod
                .number()
                .gt(listMaterialsResponseItemsItemComponentsItemTwoOneQuantityExclusiveMin)
                .describe(
                  "Positive quantity interpreted using the referenced Catalog Item unit or billing unit.",
                ),
              supplyStatus: zod.enum(["SUPPLIED", "UNSUPPLIED"]),
            })
            .and(
              zod.object({
                kind: zod.enum(["SERVICE"]),
                billingUnit: zod
                  .unknown()
                  .and(zod.unknown())
                  .and(zod.unknown())
                  .and(zod.unknown())
                  .and(zod.unknown())
                  .and(zod.unknown())
                  .and(
                    zod.object({
                      code: zod.enum(["HOUR", "DAY", "JOB", "UNIT", "M", "M2"]),
                      name: zod.string(),
                      symbol: zod.string(),
                    }),
                  )
                  .describe("Fixed Service billing-unit entry."),
              }),
            )
            .and(
              zod.object({
                kind: zod.enum(["SERVICE"]),
              }),
            ),
        ]),
      ),
      notes: zod.array(
        zod.object({
          noteId: zod.int().describe("Note identity."),
          createdAt: zod.iso.datetime({offset: true}),
          updatedAt: zod.iso.datetime({offset: true}),
          title: zod.string(),
          content: zod.string(),
        }),
      ),
    }),
  ),
  meta: zod
    .object({
      total: zod.int().min(listMaterialsResponseMetaTotalMin).describe("Total matching items."),
      page: zod.int().min(1).describe("Current 1-indexed page."),
      perPage: zod.int().min(1).describe("Requested items per page."),
    })
    .describe("Metadata for a paginated collection."),
});

/**
 * @summary Create material
 */
export const createMaterialBodyTwoComponentsItemQuantityExclusiveMin = 0;

export const CreateMaterialBody = zod.union([
  zod.object({
    compositionKind: zod.enum(["SIMPLE"]),
    code: zod.string(),
    name: zod.string(),
    internalDescription: zod.string(),
    priceProtected: zod.boolean(),
    unitOfMeasure: zod.enum(["KG", "M", "L", "UNIT", "M2", "M3"]),
    initialSupplierId: zod.uuid().describe("Supplier identity."),
  }),
  zod.object({
    compositionKind: zod.enum(["COMPOSITE"]),
    code: zod.string(),
    name: zod.string(),
    internalDescription: zod.string(),
    priceProtected: zod.boolean(),
    unitOfMeasure: zod.enum(["KG", "M", "L", "UNIT", "M2", "M3"]),
    components: zod
      .array(
        zod.object({
          componentCatalogItemId: zod
            .uuid()
            .describe("Identity shared by Material and Service Catalog Items."),
          quantity: zod
            .number()
            .gt(createMaterialBodyTwoComponentsItemQuantityExclusiveMin)
            .describe(
              "Positive quantity interpreted using the referenced Catalog Item unit or billing unit.",
            ),
        }),
      )
      .min(1),
  }),
]);

export const CreateMaterialResponse = zod
  .uuid()
  .describe("Identity shared by Material and Service Catalog Items.");

/**
 * @summary Get material
 */
export const getMaterialQueryIncludeDeletedDefault = false;

export const GetMaterialQueryParams = zod.object({
  includeDeleted: zod.boolean().default(getMaterialQueryIncludeDeletedDefault),
});

export const getMaterialResponseComponentsItemOneOneQuantityExclusiveMin = 0;

export const getMaterialResponseComponentsItemTwoOneQuantityExclusiveMin = 0;

export const GetMaterialResponse = zod.object({
  materialId: zod.uuid().describe("Identity shared by Material and Service Catalog Items."),
  kind: zod.enum(["MATERIAL"]),
  state: zod.enum(["ACTIVE", "DELETED"]),
  createdAt: zod.iso.datetime({offset: true}),
  updatedAt: zod.iso.datetime({offset: true}),
  deletedAt: zod.iso.datetime({offset: true}).nullable(),
  code: zod.string(),
  name: zod.string(),
  internalDescription: zod.string(),
  priceProtected: zod.boolean(),
  unitOfMeasure: zod
    .unknown()
    .and(zod.unknown())
    .and(zod.unknown())
    .and(zod.unknown())
    .and(zod.unknown())
    .and(zod.unknown())
    .and(
      zod.object({
        code: zod.enum(["KG", "M", "L", "UNIT", "M2", "M3"]),
        name: zod.string(),
        symbol: zod.string(),
      }),
    )
    .describe("Fixed physical Material unit entry."),
  descriptionEntries: zod.array(
    zod.object({
      language: zod.enum(["ES", "EN", "FR"]).describe("Supported business language."),
      text: zod.string(),
    }),
  ),
  functionIds: zod.array(zod.uuid().describe("Material Function identity.")),
  compositionKind: zod.enum(["SIMPLE", "COMPOSITE"]),
  supplyStatus: zod.enum(["SUPPLIED", "UNSUPPLIED"]),
  components: zod.array(
    zod.union([
      zod
        .object({
          componentCatalogItemId: zod
            .uuid()
            .describe("Identity shared by Material and Service Catalog Items."),
          state: zod.enum(["ACTIVE", "DELETED"]),
          code: zod.string(),
          name: zod.string(),
          quantity: zod
            .number()
            .gt(getMaterialResponseComponentsItemOneOneQuantityExclusiveMin)
            .describe(
              "Positive quantity interpreted using the referenced Catalog Item unit or billing unit.",
            ),
          supplyStatus: zod.enum(["SUPPLIED", "UNSUPPLIED"]),
        })
        .and(
          zod.object({
            kind: zod.enum(["MATERIAL"]),
            unitOfMeasure: zod
              .unknown()
              .and(zod.unknown())
              .and(zod.unknown())
              .and(zod.unknown())
              .and(zod.unknown())
              .and(zod.unknown())
              .and(
                zod.object({
                  code: zod.enum(["KG", "M", "L", "UNIT", "M2", "M3"]),
                  name: zod.string(),
                  symbol: zod.string(),
                }),
              )
              .describe("Fixed physical Material unit entry."),
          }),
        )
        .and(
          zod.object({
            kind: zod.enum(["MATERIAL"]),
          }),
        ),
      zod
        .object({
          componentCatalogItemId: zod
            .uuid()
            .describe("Identity shared by Material and Service Catalog Items."),
          state: zod.enum(["ACTIVE", "DELETED"]),
          code: zod.string(),
          name: zod.string(),
          quantity: zod
            .number()
            .gt(getMaterialResponseComponentsItemTwoOneQuantityExclusiveMin)
            .describe(
              "Positive quantity interpreted using the referenced Catalog Item unit or billing unit.",
            ),
          supplyStatus: zod.enum(["SUPPLIED", "UNSUPPLIED"]),
        })
        .and(
          zod.object({
            kind: zod.enum(["SERVICE"]),
            billingUnit: zod
              .unknown()
              .and(zod.unknown())
              .and(zod.unknown())
              .and(zod.unknown())
              .and(zod.unknown())
              .and(zod.unknown())
              .and(
                zod.object({
                  code: zod.enum(["HOUR", "DAY", "JOB", "UNIT", "M", "M2"]),
                  name: zod.string(),
                  symbol: zod.string(),
                }),
              )
              .describe("Fixed Service billing-unit entry."),
          }),
        )
        .and(
          zod.object({
            kind: zod.enum(["SERVICE"]),
          }),
        ),
    ]),
  ),
  notes: zod.array(
    zod.object({
      noteId: zod.int().describe("Note identity."),
      createdAt: zod.iso.datetime({offset: true}),
      updatedAt: zod.iso.datetime({offset: true}),
      title: zod.string(),
      content: zod.string(),
    }),
  ),
});

/**
 * @summary Update material
 */
export const UpdateMaterialBody = zod.object({
  code: zod.string(),
  name: zod.string(),
  internalDescription: zod.string(),
  unitOfMeasure: zod.enum(["KG", "M", "L", "UNIT", "M2", "M3"]),
});

export const UpdateMaterialResponse = zod.void();

/**
 * @summary Delete material
 */
export const DeleteMaterialResponse = zod.void();

/**
 * @summary Restore material
 */
export const RestoreMaterialResponse = zod.void();
